export const LOGO_BW_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="56" height="56" fill="none" stroke="#000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><circle cx="32" cy="32" r="29"/><path d="M14 32h36M20 24v16M44 24v16M26 20v24M38 20v24"/></svg>`;

export const AUTO_KEY = "gym_recu_auto";
export const getAutoPrint = () => localStorage.getItem(AUTO_KEY) === "1";
export const setAutoPrint = (v) => localStorage.setItem(AUTO_KEY, v ? "1" : "0");
